<script setup>
import PageHero from '@/views/front-pages/PageHero.vue'
import PublicPageShell from '@/views/front-pages/PublicPageShell.vue'
import { useConfigStore } from '@core/stores/config'

definePage({ meta: { layout: 'blank', public: true } })

const store = useConfigStore()

store.skin = 'default'

const sections = [
  {
    title: '1. Layanan',
    body: [
      'PintuKasir adalah layanan kasir (POS) berbasis langganan untuk 1 outlet coffee shop/UMKM F&B per pendaftaran. Punya beberapa cabang? Setiap outlet perlu mendaftar dan berlangganan secara terpisah.',
      'Fitur yang tersedia mengikuti paket (Starter/Pro/Premium) yang Anda pilih saat mendaftar, sebagaimana tercantum di halaman Harga.',
    ],
  },
  {
    title: '2. Pembayaran & Aktivasi',
    body: [
      'Tidak ada masa trial otomatis. Akun aktif setelah pembayaran dikonfirmasi -- otomatis lewat payment gateway (Xendit), atau manual lewat verifikasi transfer bank oleh tim kami.',
      'Langganan ditagih per periode yang Anda pilih (3 bulan/6 bulan/tahunan). Anda bisa upgrade atau downgrade paket kapan saja melalui dashboard, dengan selisih biaya dihitung secara proporsional (prorate).',
      'Perpanjangan langganan yang akan/sudah berakhir bisa dilakukan mandiri lewat dashboard (self-service).',
    ],
  },
  {
    title: '3. Pembatalan & Data Setelah Berhenti',
    body: [
      'Anda bisa berhenti berlangganan kapan saja dengan tidak memperpanjang di akhir periode berjalan -- tidak ada kontrak jangka panjang yang mengikat.',
      'Data Anda tetap kami simpan selama 90 hari setelah langganan berakhir untuk keperluan pemulihan bila Anda ingin melanjutkan kembali. Anda bisa export data kapan saja selama periode ini. Setelah 90 hari, data dihapus permanen.',
      'Pembayaran yang sudah masuk untuk periode berjalan pada dasarnya tidak dikembalikan (non-refundable) kecuali ada kesepakatan tertulis lain dengan tim kami.',
    ],
  },
  {
    title: '4. Batasan Tanggung Jawab',
    body: [
      'PintuKasir berupaya menjaga layanan tetap tersedia dan data Anda aman, namun tidak menjamin layanan bebas gangguan/error sepenuhnya (force majeure, gangguan pihak ketiga seperti penyedia hosting/payment gateway, dll di luar kendali wajar kami).',
      'Anda bertanggung jawab atas keakuratan data yang diinput ke sistem (harga, stok, resep, dll) dan atas keamanan kredensial akun staf Anda sendiri.',
      'Biaya transaksi (MDR) dari penyedia payment gateway pihak ketiga (mis. Midtrans/Xendit) dibebankan sesuai tarif penyedia tersebut, di luar biaya langganan PintuKasir.',
    ],
  },
  {
    title: '5. Penggunaan Wajar',
    body: [
      'Setiap paket memiliki batas wajar (jumlah user, produk, dan transaksi per bulan) sebagaimana tercantum di halaman Harga. Penggunaan di luar batas paket yang dipilih memerlukan upgrade ke paket yang sesuai.',
      'Dilarang menggunakan layanan untuk aktivitas ilegal atau menyalahgunakan sistem (mis. percobaan akses ke data tenant lain, spam, dll).',
    ],
  },
]
</script>

<template>
  <PublicPageShell>
    <PageHero
      eyebrow="Legal"
      eyebrow-icon="ri-file-list-3-line"
      title="Syarat & Ketentuan"
      subtitle="Ketentuan penggunaan layanan PintuKasir yang perlu Anda ketahui sebelum berlangganan."
    />

    <section class="legal-section pb-16">
      <VContainer>
        <VRow justify="center">
          <VCol
            cols="12"
            md="9"
            lg="8"
          >
            <VCard rounded="xl" variant="outlined">
              <VCardText class="pa-6 pa-md-8">
                <p class="text-caption text-medium-emphasis mb-6">
                  Terakhir diperbarui: Agustus 2026
                </p>

                <div
                  v-for="section in sections"
                  :key="section.title"
                  class="mb-6"
                >
                  <h2 class="text-h6 font-weight-bold mb-3">
                    {{ section.title }}
                  </h2>
                  <ul class="legal-list">
                    <li
                      v-for="(line, i) in section.body"
                      :key="i"
                      class="text-body-2 text-medium-emphasis mb-2"
                      style="line-height: 1.7"
                    >
                      {{ line }}
                    </li>
                  </ul>
                </div>
              </VCardText>
            </VCard>
          </VCol>
        </VRow>
      </VContainer>
    </section>
  </PublicPageShell>
</template>

<style lang="scss" scoped>
.legal-list {
  padding-inline-start: 1.25rem;
  margin: 0;
}
</style>
